export default "__VITE_ASSET__CHFIXX91__"